export const LIST_USER = 'user/LIST_USER'
export const ALL_USER = 'user/ALL_USER'
export const SHOW_USER = 'user/SHOW_USER'
export const REGISTER_USER = 'user/REGISTER_USER'
export const UPDATE_USER = 'user/UPDATE_USER'
export const REMOVE_USER = 'user/REMOVE_USER'

export const LIST_ACCOUNT = 'account/LIST_ACCOUNT'
export const LIST_ACCOUNTCOUNTRY = 'accountcountry/LIST_ACCOUNTCOUNTRY'
export const ALL_ACCOUNT = 'account/ALL_ACCOUNT'
export const SHOW_ACCOUNT = 'account/SHOW_ACCOUNT'
export const REGISTER_ACCOUNT = 'account/REGISTER_ACCOUNT'
export const UPDATE_ACCOUNT = 'account/UPDATE_ACCOUNT'
export const REMOVE_ACCOUNT = 'account/REMOVE_ACCOUNT'

export const LIST_PROJECT = 'project/LIST_PROJECT'
export const ALL_PROJECT = 'project/ALL_PROJECT'
export const SHOW_PROJECT = 'project/SHOW_PROJECT'
export const REGISTER_PROJECT = 'project/REGISTER_PROJECT'
export const UPDATE_PROJECT = 'project/UPDATE_PROJECT'
export const REMOVE_PROJECT = 'project/REMOVE_PROJECT'

export const LIST_TEAM = 'team/LIST_TEAM'
export const ALL_TEAM = 'team/ALL_TEAM'
export const SHOW_TEAM = 'team/SHOW_TEAM'
export const REGISTER_TEAM = 'team/REGISTER_TEAM'
export const UPDATE_TEAM = 'team/UPDATE_TEAM'
export const REMOVE_TEAM = 'team/REMOVE_TEAM'

export const LIST_CAMPAIGN = 'campaign/LIST_CAMPAIGN'
export const ALL_CAMPAIGN = 'campaign/ALL_CAMPAIGN'
export const SHOW_CAMPAIGN = 'campaign/SHOW_CAMPAIGN'
export const REGISTER_CAMPAIGN = 'campaign/REGISTER_CAMPAIGN'
export const UPDATE_CAMPAIGN = 'campaign/UPDATE_CAMPAIGN'
export const REMOVE_CAMPAIGN = 'campaign/REMOVE_CAMPAIGN'

export const LIST_SOCIALREASON = 'socialreason/LIST_SOCIALREASON'
export const ALL_SOCIALREASON = 'socialreason/ALL_SOCIALREASON'
export const REGISTER_SOCIALREASON = 'socialreason/REGISTER_SOCIALREASON'
export const UPDATE_SOCIALREASON = 'socialreason/UPDATE_SOCIALREASON'

export const REGISTER_TRMCHANGE = 'trmchange/REGISTER_TRMCHANGE'

export const LIST_SUPPLIER = 'supplier/LIST_SUPPLIER'
export const ALL_SUPPLIER = 'supplier/ALL_SUPPLIER'
export const SHOW_SUPPLIER = 'supplier/SHOW_SUPPLIER'
export const REGISTER_SUPPLIER = 'supplier/REGISTER_SUPPLIER'
export const UPDATE_SUPPLIER = 'supplier/UPDATE_SUPPLIER'

export const ALL_SUPPLIERACCOUNT = 'supplieraccount/ALL_SUPPLIERACCOUNT'
export const REGISTER_SUPPLIERACCOUNT =
  'supplieraccount/REGISTER_SUPPLIERACCOUNT'
export const UPDATE_SUPPLIERACCOUNT = 'supplieraccount/UPDATE_SUPPLIERACCOUNT'

export const ALL_SUPPLIERSOCIALREASON =
  'suppliersocialreason/ALL_SUPPLIERSOCIALREASON'
export const REGISTER_SUPPLIERSOCIALREASON =
  'suppliersocialreason/REGISTER_SUPPLIERSOCIALREASON'
export const UPDATE_SUPPLIERSOCIALREASON =
  'suppliersocialreason/UPDATE_SUPPLIERSOCIALREASON'

export const LIST_CLIENT = 'client/LIST_CLIENT'
export const ALL_CLIENT = 'client/ALL_CLIENT'
export const SHOW_CLIENT = 'client/SHOW_CLIENT'
export const REGISTER_CLIENT = 'client/REGISTER_CLIENT'
export const UPDATE_CLIENT = 'client/UPDATE_CLIENT'

export const ALL_CLIENTACCOUNT = 'clientaccount/ALL_CLIENTACCOUNT'
export const REGISTER_CLIENTACCOUNT = 'clientaccount/REGISTER_CLIENTACCOUNT'
export const UPDATE_CLIENTACCOUNT = 'clientaccount/UPDATE_CLIENTACCOUNT'

export const LIST_BUDGET = 'budget/LIST_BUDGET'
export const LIST_BUDGETSTATE = 'budgetstate/LIST_BUDGETSTATE'
export const ALL_BUDGET = 'budget/ALL_BUDGET'
export const SHOW_BUDGET = 'budget/SHOW_BUDGET'
export const REGISTER_BUDGET = 'budget/REGISTER_BUDGET'
export const UPDATE_BUDGET = 'budget/UPDATE_BUDGET'
export const REMOVE_BUDGET = 'budget/REMOVE_BUDGET'

export const LIST_BUDGETELEMENT = 'budgetelement/LIST_BUDGETELEMENT'
export const ALL_BUDGETELEMENT = 'budgetelement/ALL_BUDGETELEMENT'
export const SHOW_BUDGETELEMENT = 'budgetelement/SHOW_BUDGETELEMENT'
export const REGISTER_BUDGETELEMENT = 'budgetelement/REGISTER_BUDGETELEMENT'
export const UPDATE_BUDGETELEMENT = 'budgetelement/UPDATE_BUDGETELEMENT'
export const REMOVE_BUDGETELEMENT = 'budgetelement/REMOVE_BUDGETELEMENT'

export const LIST_TASK = 'task/LIST_TASK'
export const LIST_TASKSTATE = 'taskstate/LIST_TASKSTATE'
export const ALL_TASKVERSION = 'taskversion/ALL_TASKVERSION'
export const SHOW_TASKVERSION = 'taskversion/SHOW_TASKVERSION'
export const ALL_TASK = 'task/ALL_TASK'
export const SHOW_TASK = 'task/SHOW_TASK'
export const REGISTER_TASK = 'task/REGISTER_TASK'
export const REGISTER_TASKVERSION = 'taskversion/REGISTER_TASKVERSION'
export const UPDATE_TASK = 'task/UPDATE_TASK'
export const REMOVE_TASK = 'task/REMOVE_TASK'

export const REMOVE_POINT = 'point/REMOVE_POINT'

export const LIST_EMAIL = 'email/LIST_EMAIL'
export const LIST_EMAILSTATE = 'emailstate/LIST_EMAILSTATE'
export const ALL_EMAILVERSION = 'emailversion/ALL_EMAILVERSION'
export const SHOW_EMAILVERSION = 'emailversion/SHOW_EMAILVERSION'
export const ALL_EMAIL = 'email/ALL_EMAIL'
export const SHOW_EMAIL = 'email/SHOW_EMAIL'
export const REGISTER_EMAIL = 'email/REGISTER_EMAIL'
export const REGISTER_EMAILVERSION = 'emailversion/REGISTER_EMAILVERSION'
export const UPDATE_EMAIL = 'email/UPDATE_EMAIL'
export const REMOVE_EMAIL = 'email/REMOVE_EMAIL'
export const SHOW_EMAILCHECK = 'emailcheck/SHOW_EMAILCHECK'
export const LIST_EMAILCHECK = 'emailcheck/LIST_EMAILCHECK'
export const REGISTER_EMAILCHECK = 'emailcheck/REGISTER_EMAILCHECK'
export const ALL_EMAILCHECK = 'emailcheck/ALL_EMAILCHECK'
export const ALL_EMAILCLASSIFICATION =
  'emailclassification/ALL_EMAILCLASSIFICATION'
export const SHOW_EMAILCLASSIFICATION =
  'emailclassification/SHOW_EMAILCLASSIFICATION'
export const REGISTER_EMAILCLASSIFICATION =
  'emailclassification/REGISTER_EMAILCLASSIFICATION'

export const LIST_PROFILE = 'profile/LIST_PROFILE'
export const ALL_PROFILE = 'profile/ALL_PROFILE'
export const SHOW_PROFILE = 'profile/SHOW_PROFILE'
export const REGISTER_PROFILE = 'profile/REGISTER_PROFILE'
export const UPDATE_PROFILE = 'profile/UPDATE_PROFILE'
export const REMOVE_PROFILE = 'profile/REMOVE_PROFILE'

export const LIST_HOUR = 'hour/LIST_HOUR'
export const ALL_HOUR = 'hour/ALL_HOUR'
export const SHOW_HOUR = 'hour/SHOW_HOUR'
export const REGISTER_HOUR = 'hour/REGISTER_HOUR'
export const UPDATE_HOUR = 'hour/UPDATE_HOUR'
export const REMOVE_HOUR = 'hour/REMOVE_HOUR'

export const LIST_CALENDAR = 'calendar/LIST_CALENDAR'
export const ALL_CALENDAR = 'calendar/ALL_CALENDAR'
export const SHOW_CALENDAR = 'calendar/SHOW_CALENDAR'
export const REGISTER_CALENDAR = 'calendar/REGISTER_CALENDAR'
export const UPDATE_CALENDAR = 'calendar/UPDATE_CALENDAR'
export const REMOVE_CALENDAR = 'calendar/REMOVE_CALENDAR'

export const LIST_NOTIFICATION = 'notification/LIST_NOTIFICATION'
export const UPDATE_NOTIFICATION = 'notification/UPDATE_NOTIFICATION'

export const ALL_ACCOUNTUSER = 'accountuser/ALL_ACCOUNTUSER'
export const REGISTER_ACCOUNTUSER = 'accountuser/REGISTER_ACCOUNTUSER'
export const UPDATE_ACCOUNTUSER = 'accountuser/UPDATE_ACCOUNTUSER'

export const LIST_LIBRARY = 'library/LIST_LIBRARY'
export const ALL_LIBRARY = 'library/ALL_LIBRARY'
export const SHOW_LIBRARY = 'library/SHOW_LIBRARY'
export const REGISTER_LIBRARY = 'library/REGISTER_LIBRARY'
export const UPDATE_LIBRARY = 'library/UPDATE_LIBRARY'
export const REMOVE_LIBRARY = 'library/REMOVE_LIBRARY'

export const LIST_ACTIVITY = 'activity/LIST_ACTIVITY'
export const ALL_ACTIVITY = 'activity/ALL_ACTIVITY'
export const SHOW_ACTIVITY = 'activity/SHOW_ACTIVITY'
export const REGISTER_ACTIVITY = 'activity/REGISTER_ACTIVITY'
export const UPDATE_ACTIVITY = 'activity/UPDATE_ACTIVITY'
export const REMOVE_ACTIVITY = 'activity/REMOVE_ACTIVITY'

export const SESSION = 'user/SESSION'
export const LOGIN = 'user/LOGIN'
export const REGISTER_AUTH = 'auth/REGISTER_AUTH'
export const SESSION_ACCOUNT = 'SESSION_ACCOUNT'
export const SESSION_TEAM = 'SESSION_TEAM,'
export const LOGOUT = 'user/LOGOUT'
export const SIGNUP = 'user/SIGNUP'

export const ALL_NOTIFICATION = 'notification/ALL_NOTIFICATION'

export const SET_lOADING = 'SET_lOADING'



// WEBPACK FOOTER //
// ./src/vuex/entity/mutation-types.js